import { onScrollEnd } from '../utils/debounce';

// Menu button contrast: highlighted while a dark section is behind it (the
// section starts above the viewport top and reaches more than 100px into it).
export default function menuContrast() {
    const toggles = document.querySelectorAll('.menu-toggle');

    onScrollEnd(() => {
        const overDark = [...document.querySelectorAll('section.dark')].some((section) => {
            const rect = section.getBoundingClientRect();
            return rect.top <= 0 && rect.top + rect.height > 100;
        });
        toggles.forEach((t) => t.classList.toggle('highlight', overDark));
    });
}
